import { computed, Inject, Injectable, signal } from '@angular/core';
import { ApiClientConfig } from './services/api-client-config';

@Injectable({ providedIn: 'root' })
export class DeveloperModeService {
  readonly isNoProduction = signal(!this.config?.env?.production);

  readonly enabled = signal(false);

  readonly debugModeEnabled = computed(
    () => this.isNoProduction() && this.enabled()
  );

  constructor(@Inject(ApiClientConfig) private config: ApiClientConfig) {}

  toggle() {
    if (!this.isNoProduction()) {
      return;
    }
    this.enabled.update((v) => !v);
  }
}
